import React from 'react';
import { useFormContext } from 'react-hook-form';

const BoatCard = ({ index }) => {
    const { register, formState: { errors } } = useFormContext();
    const prefix = `boats.${index}`;
    const error = errors?.boats?.[index];

    return (
        <div className="grid grid-cols-6 gap-4 pr-8">
            <div className="col-span-6 sm:col-span-2">
                <label className="block text-xs font-medium text-gray-700">Year</label>
                <input
                    type="number"
                    {...register(`${prefix}.boat_year`, { valueAsNumber: true })}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
            </div>

            <div className="col-span-6 sm:col-span-2">
                <label className="block text-xs font-medium text-gray-700">Make *</label>
                <input
                    type="text"
                    {...register(`${prefix}.boat_make`)}
                    className={`mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 ${error?.boat_make ? 'border-red-300' : ''}`}
                />
                {error?.boat_make && <span className="text-xs text-red-500">{error.boat_make.message}</span>}
            </div>

            <div className="col-span-6 sm:col-span-2">
                <label className="block text-xs font-medium text-gray-700">Model *</label>
                <input
                    type="text"
                    {...register(`${prefix}.boat_model`)}
                    className={`mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 ${error?.boat_model ? 'border-red-300' : ''}`}
                />
                {error?.boat_model && <span className="text-xs text-red-500">{error.boat_model.message}</span>}
            </div>

            <div className="col-span-6 sm:col-span-2">
                <label className="block text-xs font-medium text-gray-700">Length (ft)</label>
                <input
                    type="number"
                    step="0.1"
                    {...register(`${prefix}.boat_length`, { valueAsNumber: true })}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
            </div>

            <div className="col-span-6 sm:col-span-2">
                <label className="block text-xs font-medium text-gray-700">TX Number</label>
                <input
                    type="text"
                    {...register(`${prefix}.boat_tx_number`)}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="TX-1234-AB"
                />
            </div>

            <div className="col-span-6 sm:col-span-2">
                <label className="block text-xs font-medium text-gray-700">HIN</label>
                <input
                    type="text"
                    {...register(`${prefix}.boat_hin`)}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
            </div>

            <div className="col-span-6 sm:col-span-3">
                <label className="block text-xs font-medium text-gray-700">Motor Type</label>
                <select
                    {...register(`${prefix}.motor_type`)}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                >
                    <option value="">Select...</option>
                    <option value="Outboard">Outboard</option>
                    <option value="Inboard">Inboard</option>
                    <option value="Sterndrive">Sterndrive</option>
                    <option value="Jet">Jet</option>
                </select>
            </div>

            <div className="col-span-6 sm:col-span-3">
                <label className="block text-xs font-medium text-gray-700">Horsepower</label>
                <input
                    type="number"
                    {...register(`${prefix}.motor_horse_power`, { valueAsNumber: true })}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
            </div>

            <div className="col-span-6">
                <label className="block text-xs font-medium text-gray-700">Name</label>
                <input
                    type="text"
                    {...register(`${prefix}.boat_name`)}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="The Black Pearl"
                />
            </div>
        </div>
    );
};

export default BoatCard;
